module.exports = __webpack_public_path__ + "img/presta.30e86fc9.png";